import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// common components
import PageHeader from './../../common/PageHeader/PageHeader';
import Modal from './../../common/Modal/Modal';
import Pagination from './../../common/Pagination/Pagination';
// components
import ManageBatch from './ManageBatch/ManageBatch';
import BatchList from './BatchList/BatchList';

class Batch extends Component {
	constructor(props) {
		super(props);
		this.state = {
            modalOpen: false,
            title: '',
            currentId: '',
            batchDetails: {
                course_id: '',
                name: '',
                description: '',
                city: '',
                country: '',
                end_date: new Date(),
                start_date: new Date(),
                end_time: new Date(),
                start_time: new Date()
            },
            errorBatchDetails: {
                course_id: true,
                name: true,
                description: true,
                city: true,
                country: true
            }
        }
		this.manageBatch = this.manageBatch.bind(this);        
        this.goToBatchDetails = this.goToBatchDetails.bind(this); 
		this.onChange = this.onChange.bind(this); 
        this.batchUpdate = this.batchUpdate.bind(this);
        this.onChangePicker = this.onChangePicker.bind(this);             
	}

    componentDidMount() {
        const { batchContext, courseContext } = this.props;
        // courseContext.getCourseList();
        batchContext.getBatchList(1, 25);
    }

    componentWillUnMount() {
        this.props.batchContext.clearBatchList();
        this.props.commonContext.updatePagination();
        this.props.commonContext.updateLoaderMsg();
    }

    componentWillReceiveProps(nextProps) {
        const { title } = this.state;
        const { batchDetails: {
            course_id, name, description, city, country, end_date, end_time, start_date, start_time
        } } = nextProps.batchContext;

        const { courseList } = nextProps.courseContext;

        if (courseList && courseList.length > 0) {
            this.setState({
                batchDetails: {
                    ...this.state.batchDetails,
                    course_id: courseList[0].id
                },
                errorBatchDetails: {
                    ...this.state.errorBatchDetails,
                    course_id: false
                }
            });
        }
        if ( title === 'edit') {
            let a = moment(new Date(), end_time);
            this.setState({
                batchDetails: {
                    course_id, name, description, city, country,
                    end_date, end_time: moment(new Date(), end_time),
                    start_date, start_time: moment(new Date(), start_time)
                },
                errorBatchDetails: {
                    course_id: !course_id || course_id === '',
                    name: !name || name === '',
                    description: !description || description === '',
                    city: !city || city === '',
                    country: !country || country === ''
                }
            });
        }
    }

    // pagination
    onChangePage = (curr_page, size) => {
        this.props.batchContext.getBatchList(curr_page, size);
    }

    manageBatch(value, title=null, id=null) {
        const { batchContext } = this.props;
        const activeCourse = this.props.courseContext.courseList.filter((item) => item.active==='Y');
        if(value) {
            if(title !== 'add') {
                this.setState({ currentId: id });
                if(title === 'edit') {
                    batchContext.getBatchDetails(id);
                }
            } else {
                this.setState({
                    batchDetails: {
                        ...this.state.batchDetails,
                        course_id: activeCourse[0].id,
                        name: '',
                        description: '',
                        country: '',
                        city: '',
                        start_date: new Date(),
                        end_date: new Date(),
                        start_time: new Date(),
                        end_time: new Date()
                    },
                    errorBatchDetails: {
                        course_id: false,
                        name: true,
                        description: true,
                        city: true,
                        country: true
                    }
                });
            }
        } else {
            this.setState({
                currentId: '',
                batchDetails: {
                    ...this.state.batchDetails,
                    course_id: this.props.courseContext.courseList[0].id,
                    name: '',
                    description: '',
                    country: '',
                    city: '',
                    start_date: new Date(),
                    end_date: new Date(),
                    start_time: new Date(),
                    end_time: new Date()
                },
                errorBatchDetails: {
                    course_id: false,
                    name: true,
                    description: true,
                    city: true,
                    country: true
                }
            });
            batchContext.clearBatchDetails();
        }
        this.setState({ modalOpen: value, title });
    }

    onChange = (e, val) => {
        this.setState({
            batchDetails: {
                ...this.state.batchDetails,
                [e.target.name]: e.target.value
            },
            errorBatchDetails: {
                ...this.state.errorBatchDetails,
                [e.target.name]: val
            }
        });
    }

    onChangePicker = (name, value) => {
        this.setState({
            batchDetails: {
                ...this.state.batchDetails,
                [name]: value
            }
        });
    }

    // confirm button
    batchUpdate = () => {
        const {
            title, currentId,
            batchDetails: {
                course_id, name, description, country, city, start_date, end_date, start_time, end_time
            }
        } = this.state;
        const { updateBatchDetails, addBatchDetails, deleteBatch } = this.props.batchContext;

        if (title === 'edit') {
            let data = {
                id: currentId, course_id: parseInt(course_id), name, description, country, city,
                start_date: new Date(start_date).toISOString().substring(0, 10),
                end_date: new Date(end_date).toISOString().substring(0, 10),
                start_time: new Date(start_time).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'}),
                end_time: new Date(end_time).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'})
            }
            updateBatchDetails(data);
        } else if (title === 'add') {
            let data = {
                course_id: parseInt(course_id), name, description, country, city,
                start_date: start_date.toISOString().substring(0, 10),
                end_date: end_date.toISOString().substring(0, 10),
                start_time: new Date(start_time).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'}),
                end_time: new Date(end_time).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'})
            }
            addBatchDetails(data);
        } else if (title === 'delete') {
            deleteBatch(currentId);
        }
    }
    
    goToBatchDetails(batch_id) {
		this.props.history.push(`${this.props.match.url}/bp/${batch_id}`);
	}

    onDisable = (ers) => {
        const value = Object.keys(ers).some(val => ers[val] === true);
        return value;
    }

	render () {
        const { batchList } = this.props.batchContext;
        const { pagination } = this.props.commonContext;
        const { courseList } = this.props.courseContext;
        const { batchDetails } = this.state;
        
        let optionEmpty = Object.values(batchDetails).some(item => item === '');
        const disabled = optionEmpty;

		return (
			<div className='Batch'>
                <PageHeader
                    title='batch'
                    btnText='batch'                    
					onAdd={() => this.manageBatch(true,'add')}
				/>				
				<BatchList
					manageBatch={this.manageBatch}
                    batchDetails={this.goToBatchDetails}
                    batchList={batchList}
				/>
                {pagination && pagination.totalElements > 0 &&
                    <Pagination
                        totalPage={pagination.totalPages}
                        onChangePage={this.onChangePage}
                        count={pagination.totalElements}
                        first={pagination.first}
                        last={pagination.last}
                    />
                }
				{/* Add, Edit, and delete batch Modal */}
                    {this.state.modalOpen &&
                        <Modal
                            modalOpen={this.state.modalOpen}
                            toggleModal={this.manageBatch}
                            disabled={this.state.title !== 'delete' && this.onDisable(this.state.errorBatchDetails)}
                            title={`${this.state.title} Batch`}
                            confirm={() => this.batchUpdate()}
                        >
                            <ManageBatch 
                                onDelete={this.state.title === 'delete'}
                                courseList={courseList}
                                onChange={(e, val)=>this.onChange(e, val)}
                                onChangePicker={(name, value) => this.onChangePicker(name, value)}
                                value={this.state.batchDetails}
                            />
                        </Modal>
                    }
				{/* Add, Edit, and delete batch Modal */}                
            </div>
		);
	}
}


Batch.propTypes = {
    history: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object)  
};

Batch.defaultProps = {
    history: {},
    match: {}
};

export default Batch;


// WEBPACK FOOTER //
// ./components/Batch/Batch.js